// extracted by css-extract-rspack-plugin
export default {"heartWrapper":"_5fbffbd9"};